import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot } from "vue";
import _imports_0 from '@/assets/images/icon/point.svg';
import _imports_1 from '@/assets/images/icon/point_g.svg';
import _imports_2 from '@/assets/images/icon/money.svg';
var _hoisted_1 = {
  class: "muki-price-displayer"
};
var _hoisted_2 = {
  class: "displayer-inner"
};
var _hoisted_3 = {
  key: 0,
  class: "displayer-item"
};
var _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "",
  srcset: ""
};
var _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: "",
  srcset: ""
};
var _hoisted_6 = {
  key: 1,
  class: "displayer-plus"
};
var _hoisted_7 = {
  key: 2,
  class: "displayer-item"
};

var _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "",
  srcset: ""
}, null, -1);

var _hoisted_9 = {
  class: "displayer-money"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock("div", _hoisted_1, [_createVNode("div", _hoisted_2, [$setup.trim($props.points) || $props.forceShowPoint ? (_openBlock(), _createBlock("div", _hoisted_3, [!$props.grayout ? (_openBlock(), _createBlock("img", _hoisted_4)) : _createCommentVNode("", true), $props.grayout ? (_openBlock(), _createBlock("img", _hoisted_5)) : _createCommentVNode("", true), _createVNode("div", {
    class: ["displayer-money", {
      'text-red': $props.grayout
    }]
  }, _toDisplayString($props.pointsPrefix) + _toDisplayString($props.points || 0), 3)])) : _createCommentVNode("", true), $setup.trim($props.points) && $setup.trim($props.price) ? (_openBlock(), _createBlock("span", _hoisted_6, "+")) : _createCommentVNode("", true), $props.price || $props.forceShowPrice ? (_openBlock(), _createBlock("div", _hoisted_7, [_hoisted_8, _createVNode("div", _hoisted_9, _toDisplayString($props.price || 0), 1)])) : _createCommentVNode("", true)]), _renderSlot(_ctx.$slots, "default")]);
}